// Thin async wrapper over the pure builders in bagQueries.js. Chains the two BAG
// OGC calls (verblijfsobject -> pand) that building facts require. Does the
// actual network I/O (keyless PDOK BAG OGC API Features v2, CORS-enabled) and is
// intentionally not unit-tested — the testable logic lives in bagQueries.js.
//
// AI-CONTEXT: See docs/features/adress-external-data.md

import {
    buildVerblijfsobjectUrl,
    buildPandUrl,
    parseVerblijfsobject,
    parsePand,
} from './bagQueries'

const getJson = async (url, signal) => {
    const res = await fetch(url, signal ? { signal } : undefined)
    if (!res.ok) throw new Error(`BAG responded ${res.status}`)
    return res.json()
}

// Resolve building facts for a BAG verblijfsobject id. Returns { vob, pand };
// pand is null when the verblijfsobject has no resolvable pand link.
const fetchBuildingFacts = async (bagId, signal) => {
    if (!bagId) return { vob: null, pand: null }
    const vob = parseVerblijfsobject(await getJson(buildVerblijfsobjectUrl(bagId), signal))
    if (!vob || !vob.pandUuid) return { vob, pand: null }
    // Bail before the second round-trip if the caller already aborted (tab/address switch).
    if (signal && signal.aborted) return { vob, pand: null }
    const pand = parsePand(await getJson(buildPandUrl(vob.pandUuid), signal))
    return { vob, pand }
}

export { fetchBuildingFacts }
